import React from 'react';

// Line icons for the campaign page, drawn in currentColor on a 32px grid.
// `fill: none` is set inline: the global `svg { fill: currentColor }` would
// otherwise fill the strokes' shapes.

const Line = ({ className, children }) => (
  <svg
    className={className}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    aria-hidden="true"
    style={{ fill: 'none' }}
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

/** A clothes hanger: "Selg det du ikke bruker". */
export const IconHanger = ({ className }) => (
  <Line className={className}>
    <path d="M13 9.5a3 3 0 1 1 4.2 2.75c-.75.33-1.2 1.08-1.2 1.9V15" />
    <path d="M16 15 4.6 22.6a1 1 0 0 0 .55 1.83h21.7a1 1 0 0 0 .55-1.83L16 15Z" />
  </Line>
);

/** A magnifier: "Finn nye favoritter". */
export const IconMagnifier = ({ className }) => (
  <Line className={className}>
    <circle cx="14" cy="14" r="8" />
    <path d="m20 20 7 7" />
  </Line>
);

/** A delivery van: "Send enkelt". */
export const IconTruck = ({ className }) => (
  <Line className={className}>
    <path d="M3 9h15v13H3z" />
    <path d="M18 13h5.5l4.5 5v4h-10" />
    <circle cx="8.5" cy="23.5" r="2.5" />
    <circle cx="22.5" cy="23.5" r="2.5" />
  </Line>
);

/** A heart: "Gratis å bli med". */
export const IconHeart = ({ className }) => (
  <Line className={className}>
    <path d="M16 26.5S4.5 19.6 4.5 11.9A5.9 5.9 0 0 1 16 9.7a5.9 5.9 0 0 1 11.5 2.2c0 7.7-11.5 14.6-11.5 14.6Z" />
  </Line>
);

/** A stack of coins: "Hva koster det å selge?". */
export const IconCoins = ({ className }) => (
  <Line className={className}>
    <ellipse cx="13" cy="9" rx="8" ry="3" />
    <path d="M5 9v5c0 1.66 3.58 3 8 3s8-1.34 8-3V9" />
    <path d="M5 14v5c0 1.66 3.58 3 8 3 1.1 0 2.15-.08 3.1-.23" />
    <ellipse cx="21" cy="20" rx="6" ry="2.4" />
    <path d="M15 20v4c0 1.33 2.69 2.4 6 2.4s6-1.07 6-2.4v-4" />
  </Line>
);

/** A check in a filled disc: the points under "Om Zuprize". */
export const IconCheckDisc = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
    <circle cx="10" cy="10" r="10" style={{ fill: 'currentColor' }} />
    <path
      d="m6 10.2 2.6 2.6L14 7.6"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ fill: 'none' }}
    />
  </svg>
);
